import React from 'react'
import CircleDate from '../../history/circle-date'

const CardHeader = ({isJobActivity, imageHeight, imgPadding, heroImage, headerRightIcon, headerLeftIcon, headerMidIcon, textMidIcon, headerTitle, headerSubtitle, customHeaderStyle}) => {
  let divStyles, heightProp
  let iconRight, iconLeft, iconMid
  let heroCard = 'row'

  if (heroImage) {
    divStyles = {
      backgroundImage: 'url(' + heroImage + ')'
    }
    heroCard += ' card-hero'
  }

  if (imageHeight) {
    heightProp = {
      height: imageHeight
    }
  }

  let iconWrapper = ''

  if (headerLeftIcon) headerLeftIcon = headerLeftIcon.replace(/(?:\r\n|\r|\n)/g, '<br />')
  let needIconWrapper = true

  if (headerRightIcon) {
    iconRight = <div className='card-icon-right task-type center small no-text'>
      <div className={`img-responsive center-block ${headerRightIcon}-circle`} />
    </div>
    iconLeft = <div className={'card-icon-left'}>
      <span className='card-icon-text' dangerouslySetInnerHTML={{ __html: headerLeftIcon }} />
    </div>
    iconMid = <div className='primary-card-icon'>
      <div className={`img-responsive center-block ${headerMidIcon}-circle`}/>
      <img role='presentation' src={headerMidIcon} className='img-responsive center-block ' />
    </div>
  } else if (headerMidIcon) {
    let finishedStyle
    if(!isJobActivity) {
      iconMid = <div className='primary-card-icon primary-card-icon-solo task-type center small no-text'>
        <div className={`img-responsive center-block ${headerMidIcon}-circle`} />
      </div>
    } else {
      if(headerMidIcon.includes('FINISHED')){
        finishedStyle = {
          height: '38px',
        }
      }
      iconMid = <div className='primary-card-icon primary-card-icon-solo'>
        <img role='presentation' style={finishedStyle} src={headerMidIcon} className='img-responsive center-block' />
      </div>
    }
  } else if (textMidIcon) {
    iconMid = <div className='hide-task'>
      <CircleDate cardDate={textMidIcon} color='#4a4a4a' style={{color: 'red', marginTop: 0}} />
    </div>
  } else {
    needIconWrapper = false
  }

  if (needIconWrapper) {
    iconWrapper = <div className='card-icon-wrapper'>
      {iconLeft}
      {iconMid}
      {iconRight}
    </div>
  }
  let headerPadding;
  if(imgPadding){
    headerPadding = {
      marginLeft: -imgPadding,
      marginRight: -imgPadding
    }
  }
  return (
    <div className={heroCard} style={{...divStyles, ...heightProp, ...headerPadding}}>
      {iconWrapper}
      <h4 className='text-center' style={{...customHeaderStyle}}>{headerTitle}<br />
      <span style={{marginTop: 10}}>{headerSubtitle}</span></h4>
    </div>
  )
}

CardHeader.propTypes = {
  heroImage: React.PropTypes.string,
  headerLeftIcon: React.PropTypes.string,
  headerMidIcon: React.PropTypes.string,
  headerRightIcon: React.PropTypes.string,
  textMidIcon: React.PropTypes.string,
  headerTitle: React.PropTypes.string,
  headerSubtitle: React.PropTypes.string
}

export default CardHeader



// WEBPACK FOOTER //
// ./src/components/shared/card/card-header.jsx